import { ReactNode } from 'react';
import { useAppTranslate } from '@src/i18n/i18n';
import { Modal } from '../Modal';
import { Button } from 'antd';
import { CheckIcon } from '@heroicons/react/24/outline';

type ConfirmModalProps = {
    title?: string;
    isOpen: boolean;
    confirmMessage: ReactNode;
    headerIcon?: ReactNode;
    loading?: boolean;
    itemName?: string;
    headerClassName?: string;
    showConfirmButton?: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export function ConfirmModal({
    title,
    isOpen,
    confirmMessage,
    headerIcon,
    loading,
    itemName,
    headerClassName,
    showConfirmButton = true,
    onClose,
    onConfirm,
}: Readonly<ConfirmModalProps>) {
    const { t } = useAppTranslate();

    return (
        <Modal
            isOpen={isOpen}
            title={title}
            headerIcon={headerIcon}
            headerClassName={headerClassName}
            onClose={() => onClose()}
            content={
                <div className="flex flex-col justify-evenly flex-1 h-20">
                    <p className="text-base">
                        <span className=" font-normal leading-normal">
                            {confirmMessage}
                        </span>
                    </p>
                    {itemName && (
                        <div className="flex items-center gap-1 font-medium text-xl">
                            <span>{itemName}</span>
                        </div>
                    )}
                </div>
            }
            footer={
                <div className="flex gap-4">
                    <Button
                        size="large"
                        className={
                            showConfirmButton
                                ? 'btn-secondary w-1/2'
                                : 'btn-secondary w-full'
                        }
                        onClick={() => onClose()}
                    >
                        {t('buttons.cancel')}
                    </Button>
                    {showConfirmButton && (
                        <Button
                            loading={loading}
                            size="large"
                            className="btn-primary w-1/2"
                            onClick={() => onConfirm()}
                            icon={<CheckIcon width={16} height={16} />}
                        >
                            {t('buttons.confirm')}
                        </Button>
                    )}
                </div>
            }
        />
    );
}
